import {useEffect,useState,useContext} from 'react'
import OrderPriceEntry from './orderPriceEntry'
import OrderPriceDetails from './orderPriceDetails'

export default function OrderPrice(){
    const [orderKey, setOrderKey] = useState('');
    const [authKey, setAuthKey] = useState(false)
    const [orderData, setOrderData] = useState()
    const [loadingKey, setLoadingKey] = useState(false)

    useEffect(() => {
        sessionStorage.removeItem("token");
    },[])

    async function checkOrderKey(key){
        setLoadingKey(true)
        try{
            fetch('https://gipapi.azurewebsites.net/compras/cotacoes', {
            //fetch('https://localhost:44303/compras/cotacoes', {
                method: "GET",
                headers:{
                    'chave-cotacao': key,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                if(json.MensagemErro != undefined){
                    setLoadingKey(false)
                    alert(json.MensagemErro)
                }
                else{
                    setLoadingKey(false)
                    setOrderKey(key)
                    setOrderData(json)
                    setAuthKey(true)
                }
            })
        }
        catch(error){
            console.log(error)
        }
    }

    return(
        <>
        {authKey?
            <OrderPriceDetails data={{orderData: orderData,key: orderKey}}/>
            :
            <OrderPriceEntry data={{insertKeyFunction: checkOrderKey,loadingKeyState: loadingKey}}/>
        }
        </>
    )
}